export enum EnumOrigemPedido {
  Loja = 'loja',
  Multiloja = 'multiloja',
  Bot = 'bot',
  Garcom = 'garcom',
  Ifood = 'ifood',
  Totem = 'totem',
}
